import { useState, useMemo } from 'react';

const useLoading = () => {
  const [isRowLoading, setIsRowLoading] = useState(false);

  const loadingClass = 'opacity-50 pointer-events-none';
  const normalClass = 'opacity-100 pointer-events-auto';

  const tableClassName = useMemo(() => {
    return `${
      isRowLoading ? loadingClass : normalClass
    } transition-opacity duration-300 ease-in-out`;
  }, [isRowLoading]);

  return {
    tableClassName,
    isRowLoading,
    setIsRowLoading
  };
};

export default useLoading;
